/* ──────────────────────────────────────────────────────────────
 * Shared date helpers (fr-FR). Used across SAV ticket views.
 * ────────────────────────────────────────────────────────────── */

/** Short relative label + a "fresh" flag (<1h). */
export const getRelativeTime = (dateString) => {
  if (!dateString) return { label: "", fresh: false };
  const date = new Date(dateString);
  const diffMs = new Date() - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return { label: "À l'instant", fresh: true };
  if (diffMin < 60) return { label: `Il y a ${diffMin} min`, fresh: true };
  if (diffHr < 24) return { label: `Il y a ${diffHr} h`, fresh: false };
  if (diffDays === 1) return { label: "Hier", fresh: false };
  if (diffDays < 7) return { label: `Il y a ${diffDays} j`, fresh: false };
  if (diffDays < 30)
    return { label: `Il y a ${Math.floor(diffDays / 7)} sem.`, fresh: false };
  if (diffDays < 365)
    return { label: `Il y a ${Math.floor(diffDays / 30)} mois`, fresh: false };
  const years = Math.floor(diffDays / 365);
  return { label: `Il y a ${years} an${years > 1 ? "s" : ""}`, fresh: false };
};

/** Compact exact time: drops the year when it's the current year. */
export const getExactTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

/** Long version for tooltips. */
export const getFullDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString("fr-FR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};